import { render, staticRenderFns } from "./PhonePreview.vue?vue&type=template&id=7e7b64d5&"
import script from "./PhonePreview.vue?vue&type=script&lang=js&"
export * from "./PhonePreview.vue?vue&type=script&lang=js&"
import style0 from "./PhonePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports